<template>
    <div class="video-box">
        <div class="item" v-for='(item,index) in someData' :key='index'>
            <img :src="item.url" :alt="item.caption" class="imgs">
            <div class="caption">{{item.caption}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ItemVideo',
        data() {
            return {
                someData: [
                    {
                        url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/photo-1512677581646-75f6e51c04e2.jpg',
                        caption: '产品拍摄'
                    },
                    {
                        url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/photo-1471341971476-ae15ff5dd4ea.jpg',
                        caption: '产品轻视频'
                    },
                    {
                        url: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/photo-1497015289639-54688650d173.jpg',
                        caption: '企业宣传视频'
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .video-box {
        width: 85.41%;
        margin: 0 auto;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 2%;
        margin-bottom: 118px;
    }

    .imgs {
        width: 100%;
    }

    .caption {
        padding: 6% 0;
        background-color: #ffffff;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        line-height: 137%;
        color: rgba(102, 102, 102, 1);
    }
    @media(max-width: 995px){
        .video-box {
        width: 90%;
        grid-template-columns: 1fr;
        grid-row-gap:0;
        grid-row-gap: 3%;
    }
    .caption {
        font-size: 16px;
    }
    }

    /* @media(max-width: 1023px){
        .video-box {
        width: 90%;
        grid-template-columns: 1fr;
        grid-row-gap:0;
    }
    .caption {
        font-size: 50px;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/case/itemVideo.vue